export default __webpack_public_path__ + "media/images/projects/project-belsen.jpg";